<template>
  <div data-view="dolo.about.v0.12020" class="content-inner max white">
    <div class="max hidden-xs-only">
      <div class="section banner">
        <div class="banner-bg grey lighten-5"></div>
        <div class="bg-rect amber-line">
        </div>
        <div class="banner-title text-center">
          <div class="title-t dolo font-weight-regular">Strategery.</div>
          <div class="title-s roboto">Better Tools. Better Results.</div>
          <v-btn x-large rounded color="white" class="t14 black--text mt-12" @click="openGetStarted()">Get Started</v-btn>
        </div>
      </div>
      <div class="section liner l bgGrey mb-4"></div>
      <div class="section liner m bgGrey mb-4"></div>
      <div class="section liner s bgGrey mb-4"></div>
      <div class="section tlg ">
        <div class="bg-circle black"></div>
        <div class="section-details">
          <v-layout row wrap fill-height justify-center>
            <v-flex xs12 md4>
              <div class="big dolo">
                Performance management at it's finest.
              </div>
            </v-flex>
            <v-flex xs12 md4>
              <div class="det-info roboto pl-12">
                Connect Strategery iQ to the software your performance is recorded, identify the areas you want to track and vwala, you can measure your performance against your goals. 
              </div>
              <!-- <div class="roboto font-weight-bold t22 pl-12 pt-12">
                <v-layout align-center>
                  Check out our integrations
                  <i class="las la-arrow-right t32 ml-2"></i>
                </v-layout>
              </div> -->
            </v-flex>
            <v-flex class="prod-container" mt-12>
              <v-layout justify-center>
                <v-card v-for="(p,i) in prodList" :key="i+'.'+p" class="mx-2 prod-card" elevation="12" width="260" height="260" @click="openProdDialog(p)">
                  <v-card-title class="dolo pc-title mb-8">
                    {{p.lulu}}
                  </v-card-title>
                  <v-card-text class="px-0 pc-logo">
                    <v-avatar size="80" tile class="logo-sm" :class="p.req">
                      <!-- <v-img contain :src="`../assets/logos/${p.logo}.png`"></v-img> -->
                    </v-avatar>
                  </v-card-text>
                </v-card>
                <!-- <v-card class="pa-6 mx-2" elevation="12" width="260" height="260">
                  <v-card-title class="dolo t32 mb-8">
                    Organize.
                  </v-card-title>
                  <v-card-text class="px-0 pt-12">
                    <v-avatar size="80" tile>
                      <v-img contain src="../assets/logos/today/td_shad2.png"></v-img>
                    </v-avatar>
                  </v-card-text>
                </v-card>
                <v-card class="pa-6 mx-2" elevation="12" width="260" height="260">
                  <v-card-title class="dolo t32 mb-8">
                    Educate.
                  </v-card-title>
                  <v-card-text class="px-0 pt-12">
                    <v-avatar size="80" tile>
                      <v-img contain src="../assets/logos/avenues/av_shad2.png"></v-img>
                    </v-avatar>
                  </v-card-text>
                </v-card>
                <v-card class="pa-6 mx-2" elevation="12" width="260" height="260">
                  <v-card-title class="dolo t32 mb-8">
                    Compare.
                  </v-card-title>
                  <v-card-text class="px-0 pt-12">
                    <v-avatar size="80" tile>
                      <v-img contain src="../assets/logos/people/pe_shad2.png"></v-img>
                    </v-avatar>
                  </v-card-text>
                </v-card> -->
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
      </div>
      <div class="section liner rt s bgGrey mb-4"></div>
      <div class="section liner rt m bgGrey mb-4"></div>
      <div class="section tmd grey lighten-5">
        <div class="bg-hollow amber-line mlb"></div>
        <div class="section-details">
          <v-layout row wrap fill-height align-center justify-center>
            <v-flex xs12 md4>
              <div class="big dolo">
                Connect to your activity. Then start tracking.
              </div>
            </v-flex>
            <v-flex xs12 md4>
              <div class="det-info roboto pl-12">
                Connect Strategery iQ to the software your performance is recorded, identify the areas you want to track and vwala, you can measure your performance against your goals. 
              </div>
              <div class="roboto font-weight-bold t22 pl-12 pt-12">
                <v-layout align-center>
                  Check out our integrations
                  <i class="las la-arrow-right t22 ml-2"></i>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </div>
      <div class="section liner  m bgGrey mb-4"></div>
      <div class="section liner l bgGrey mb-4"></div>
      <div class="section tmd">
        <div class="section-details">
          <v-layout row wrap fill-height align-center justify-center>
            <v-flex xs12 md4>
              <div class="big dolo">
                RealTime performance tracking.
              </div>
            </v-flex>
            <v-flex xs12 md4>
              <div class="det-info oboto pl-12">
                Strategery® creates access to your information in realtime. You can't improve any sooner than now and Strategery® will provide you the ability to do just that. 
              </div>
            </v-flex>
          </v-layout>
        </div>
      </div>
      <div class="section tsm">
          <div class="block-bg tertiary"></div>
          <div class="block-text roboto ls12 text-uppercase">
            Create Proactive Influence not reactive observation.
            <div class="">
              <v-layout justify-end>
                <v-card flat height="10" width="184" color="accent" class="mt-12"></v-card>
              </v-layout>
            </div>
            <div class="">
              <v-layout justify-end>
                <v-card flat height="4" width="64" color="accent" class="mt-4"></v-card>
              </v-layout>
            </div>
          </div>
      </div>
      <div class="section liner rt m bgGrey mb-4"></div>
      <div class="section liner rt s bgGrey mb-4"></div>
      <div class="section liner rt l bgGrey mb-4"></div>
      <div class="section tlg grey lighten-5 everything">
        <div class="bg-circle-ls ol accent-line"></div>
        <div class="section-details">
          <v-layout row wrap fill-height justify-center align-center>
            <v-flex xs12 md4>
              <div class="big dolo">
                Everything you need. All in one place.
              </div>
            </v-flex>
            <v-flex xs12 md4>
              <div class="det-info roboto pl-12">
                Strategery is your one stop shop for all your daily needs. No longer do you have to use multiple applications to satisfy your daily needs. 
              </div>
            </v-flex>
            <v-flex class="ev-chips-container">
              <v-chip-group
                  column
                  active-class="primary--text"
                >
                  <v-layout row wrap justify-center>
                    <v-chip large outlined color="amber" class="ev-chip roboto ma-2" v-for="(h,i) in highlights" :key="i">
                      {{ h }}
                    </v-chip>
                  </v-layout>
                </v-chip-group>
            </v-flex>
          </v-layout>
        </div>
      </div>
      <div class="section liner l bgGrey mb-4"></div>
      <div class="section liner m bgGrey mb-4"></div>
      <div class="section tsm">
          <div class="block-bg rt amber" style=""></div>
          <div class="block-text rt roboto ls12 text-uppercase">
            Measurement always precedes management.
            <div class="pr-12">
              <v-layout justify-end pr-12>
                <v-card flat height="4" width="184" color="tertiary" class="mt-12"></v-card>
              </v-layout>
            </div>
            <div class="pr-12">
              <v-layout justify-end pr-12>
                <v-card flat height="40" width="40" color="tertiary" class="mt-4" style="border-radius: 50%"></v-card>
              </v-layout>
            </div>
          </div>
      </div>
      <div class="section tmd">
        <div class="bg-hollow black-line diag-rt"></div>
        <div class="tag-sec primary white--text">
          <div class="section-details">
            <v-layout row wrap fill-height align-end>
              <v-flex xs12 md6>
                <div class="big dolo">
                  Still have questions.
                </div>
              </v-flex>
              <v-flex xs12 md6 px-12>
                <div class="det-info roboto px-12">
                  Get the answers that you need by contacting our sales team.
                </div>
                <v-layout align-center>
                  <div class="dolo px-12 pt-12">
                    Sales Team
                    <i class="las la-arrow-right t32 ml-2"></i>
                  </div>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </div>
      <div class="section liner m bgGrey mb-4"></div>
      <div class="section liner s bgGrey mb-4"></div>
      <div class="section tmd">
        <div class="section-details">
          <v-layout row wrap fill-height>
            <v-flex xs12>
              <div class="text-center">
                <v-avatar size="100" tile>
                  <v-img contain src="../assets/strat_shad2.png"></v-img>
                </v-avatar>
              </div>
            </v-flex>
            <v-flex xs12 class="mt-6">
              <v-layout justify-center>
                <div class="big dolo text-center" style="width: 70%">
                  Get Started with Strategery. It's only one click away.
                </div>
              </v-layout>
            </v-flex>
            <v-flex xs12 justify-center>
              <v-layout justify-center>
                <v-btn x-large rounded color="white" class="t14 mt-12" @click="openGetStarted()">Get Started.</v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
      </div>
      <strat-footer />
    </div>
    <div class="mobi max hidden-sm-and-up">
      <div class="section banner">
        <div class="banner-bg grey lighten-5"></div>
        <div class="bg-rect amber-line">
        </div>
        <div class="banner-title text-center">
          <div class="title-t dolo font-weight-regular">Strategery.</div>
          <div class="title-s roboto">Better Tools. Better Results.</div>
          <v-btn x-large rounded color="white" class="t14 black--text mt-4" @click="openMobiGetStarted()">Get Started</v-btn>
        </div>
      </div>
      <div class="section liner l bgGrey mb-2"></div>
      <div class="section liner m bgGrey mb-2"></div>
      <div class="section liner s bgGrey mb-2"></div>
      <div class="section tlg mega">
        <div class="bg-circle black"></div>
        <div class="section-details">
          <v-layout row wrap>
            <div>
              <div class="big dolo">
                Performance management at it's finest.
              </div>
            </div>
            <div>
              <div class="t14 mt-8 roboto">
                Connect Strategery iQ to the software your performance is recorded, identify the areas you want to track and vwala, you can measure your performance against your goals. 
              </div>
              <div class="roboto font-weight-bold t12 pt-6">
                <v-layout align-center>
                  Check out our integrations
                  <i class="las la-arrow-right t14"></i>
                </v-layout>
              </div>
            </div>
            <div class="mt-12">
              <v-layout row wrap>
                <v-card v-for="(p,i) in prodList" :key="i+'.'+p" class="pa-6 mb-2" elevation="12" width="100%" height="260" @click="openProdDialog(p)">
                  <v-card-title class="dolo t32 mb-8">
                    {{p.lulu}}
                  </v-card-title>
                  <v-card-text class="px-0 pt-12">
                    <v-avatar size="80" tile class="logo-sm" :class="p.req"></v-avatar>
                  </v-card-text>
                </v-card>
              </v-layout>
            </div>
          </v-layout>
        </div>
      </div>
      <div class="section liner rt s bgGrey mb-2"></div>
      <div class="section liner rt m bgGrey mb-2"></div>
      <div class="section tlg grey lighten-5">
        <div class="bg-hollow amber-line mlb"></div>
        <div class="section-details">
          <v-layout row wrap>
            <div xs12>
              <div class="big dolo">
                Connect to your activity. Then start tracking.
              </div>
            </div>
            <div xs12>
              <div class="t14 mt-8 roboto">
                Connect Strategery iQ to the software your performance is recorded, identify the areas you want to track and vwala, you can measure your performance against your goals. 
              </div>
              <div class="roboto font-weight-bold t12 pt-6">
                <v-layout align-center>
                  Check out our integrations
                  <i class="las la-arrow-right t14 ml-2"></i>
                </v-layout>
              </div>
            </div>
          </v-layout>
        </div>
      </div>
      <div class="section liner  m bgGrey mb-2"></div>
      <div class="section liner l bgGrey mb-2"></div>
      <div class="section tmd">
        <div class="section-details">
          <v-layout row wrap>
            <div xs12>
              <div class="big dolo">
                RealTime performance tracking.
              </div>
            </div>
            <div xs12>
              <div class="t14 mt-8 roboto">
                Strategery® creates access to your information in realtime. You can't improve any sooner than now and Strategery® will provide you the ability to do just that. 
              </div>
            </div>
          </v-layout>
        </div>
      </div>
      <div class="section tsm">
          <div class="block-bg tertiary" style="position: absolute; height: 50%; width: 64%; right: 0%; top: -10%; border-radius: 220px 0 0 220px;"></div>
          <div class="text-right roboto ls6 text-uppercase" style="position: absolute; height: 50%; width: 90%; left: 5%; top: 10%; font-size: 14px; line-height: 20px;">
            Create Proactive Influence not reactive observation.
            <div class="">
              <v-layout justify-end>
                <v-card flat height="10" width="184" color="accent" class="mt-12"></v-card>
              </v-layout>
            </div>
            <div class="">
              <v-layout justify-end>
                <v-card flat height="4" width="64" color="accent" class="mt-4"></v-card>
              </v-layout>
            </div>
          </div>
      </div>
      <div class="section liner rt m bgGrey mb-2"></div>
      <div class="section liner rt s bgGrey mb-2"></div>
      <div class="section liner rt l bgGrey mb-2"></div>
      <div class="section tlg everything grey lighten-5">
        <div class="bg-circle-ls ol accent-line"></div>
        <div class="section-details">
          <v-layout row wrap>
            <div xs12>
              <div class="big dolo">
                Everything you need. All in one place.
              </div>
            </div>
            <div xs12>
              <div class="t14 my-8 roboto">
                Strategery is your one stop shop for all your daily needs. No longer do you have to use multiple applications to satisfy your daily needs. 
              </div>
              <div class="">
                <v-chip-group
                  column
                  active-class="primary--text"
                >
                  <v-chip color="" class="t14 roboto mr-2 mb-2" v-for="(h,i) in highlights" :key="i">
                    {{ h }}
                  </v-chip>
                </v-chip-group>
              </div>
            </div>
          </v-layout>
        </div>
      </div>
      <div class="section liner l bgGrey mb-2"></div>
      <div class="section liner m bgGrey mb-2"></div>
      <div class="section tsm">
          <div class="block-bg amber" style="position: absolute; height: 50%; width: 80%; left: 0%; top: 10%; border-radius: 0 220px 220px 0;"></div>
          <div class="text-right roboto ls12 text-uppercase" style="position: absolute; height: 50%; width: 90%; right: 5%; bottom: 24%; font-size: 14px; line-height: 20px;">
            Measurement always precedes management.
            <div class="">
              <v-layout justify-end>
                <v-card flat height="2" width="92" color="tertiary" class="mt-6"></v-card>
              </v-layout>
            </div>
            <div class="">
              <v-layout justify-end>
                <v-card flat height="20" width="20" color="tertiary" class="mt-2" style="border-radius: 50%"></v-card>
              </v-layout>
            </div>
          </div>
      </div>
      <div class="section tmd">
        <div class="bg-hollow black-line diag-rt"></div>
        <div class="tag-sec primary white--text">
          <div class="section-details">
            <v-layout row wrap>
              <div class="big dolo text-center">
                Still have questions.
              </div>
              <div class="t14 roboto text-center my-6">
                Get the answers that you need by contacting our sales team.
              </div>
              <div class="dolo t20 text-center mt-4 fw">
                Sales Team
              </div>
              <div class="dolo t30 text-center fw">
                <i class="las la-arrow-right t32"></i>
              </div>
            </v-layout>
          </div>
        </div>
      </div>
      <div class="section liner m bgGrey mb-2"></div>
      <div class="section liner s bgGrey mb-2"></div>
      <div class="section tmd">
        <div class="section-details">
          <v-layout row wrap>
            <div class="fw">
              <div class="text-center justify-center">
                <v-avatar size="100" tile>
                  <v-img contain src="../assets/strat_shad2.png"></v-img>
                </v-avatar>
              </div>
            </div>
            <div class="mt-6">
              <v-layout justify-center>
                <div class="big dolo text-center">
                  Get Started with Strategery. It's only one click away.
                </div>
              </v-layout>
            </div>
            <div class="fw">
              <v-layout justify-center>
                <v-btn x-large rounded color="white" class="t14 my-6" @click="openMobiGetStarted()">Get Started.</v-btn>
              </v-layout>
            </div>
          </v-layout>
        </div>
      </div>
    </div>
    <v-dialog v-model="prodDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card color="white" class="max">
        <prod-dets :prod="prodDets" @killProdDialog="killProdDialog()" :launched="launched"/>
      </v-card>
    </v-dialog>
    <v-dialog v-model="getStartedDialog" width="60%">
        <v-card color="white" class="max overflow-hidden pa-6">
            <get-started @killGetStarted="killGetStarted()"/>
        </v-card>
    </v-dialog>
    <v-dialog v-model="mobiGetStartedDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card color="white" class="max overflow-hidden pa-6">
            <get-started @killGetStarted="killGetStarted()"/>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import prodDets from '../components/prod-dets'
import stratFooter from '../components/strat-footer'
import getStarted from '../views/contact_sales'

export default {
  name: 'home',
  components: {
    prodDets,
    stratFooter,
    getStarted
  },
  props: {},
  mounted() {
    this.homeTotal = this.windows.length

    var vm = this
    window.addEventListener('scroll', function(){
      this.scrollPos = window.scrollY
      var winHeight = window.innerHeight
      var docHeight = document.documentElement.scrollHeight
      var perc = 100 * this.scrollPos / (docHeight - winHeight)
      vm.$el.style.width = perc + '%'
    })

  },
  data: () => {
    return {
      scrollPos: 0,
      home: 0,
      homeTotal: null,
      prodDialog: false,
      prodDets: null,
      launched: false,
      highlights: [
        'Customizable Performance Tracking.',
        'Project Management.',
        'Daily Tasks.',
        'Notes.',
        'Event Calendar.',
        'Lead Tracking.',
        'Networking Events.',
        'Learning Management with measureable ROI.',
        'Pin Point Talent Acquisition.',
        'Daily Planning.',
        'Daily Tracking.',
        'Meetings.',
        'Messaging.',
        'Video Chat.',
      ],
      prodList: [
        {
          title: 'iQ®',
          lulu: 'Measure.',
          detType: 'promo',
          displayTitle: 'iQ',
          logo: 'iq/iq_shad2',
          req: 'iq',
          smarter: 'Measurement',
          color: 'amber',
          color2: 'primary2',
          tagline: 'Work Smarter.',
          desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.',
          highlights: [
            { 
              title:'Performance Measurement.',
              img: 'https://i.pinimg.com/originals/4f/54/e3/4f54e3c38b45687bb3d0ecc9d4d9c54f.png',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
            },
            { 
              title:'Create Accountability.',
              img: 'https://mir-s3-cdn-cf.behance.net/project_modules/fs/b5827590784099.5e2048449e4cc.jpg',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
            },
            { 
              title:'Customizable Metrics.',
              img: 'https://i.pinimg.com/736x/ab/12/77/ab1277b7ab0f09d1085e033794720dce--web-dashboard-dashboard-design.jpg',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
            },
            { 
              title:'Automated.',
              img: 'https://assets.justinmind.com/wp-content/uploads/2019/08/mobile-banking-app-design-best-ui-patterns-1.png',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
            },
            { 
              title:'Easy to understand results.',
              img: 'https://i.pinimg.com/originals/81/83/59/8183590a65d3096e98e1c45ec1e7f774.jpg',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
            },
            { 
              title:'iQ Report Card.',
              img: 'https://mir-s3-cdn-cf.behance.net/project_modules/fs/b8df9a90827331.5e2151aa78086.jpg',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
            },
          ],
          prodVid: 'v=lzQyH-nX0u0',
          linkOut: 'iq.dololabs.com',
          bgImg: '',
          appleOut: '',
          androidOut: '',
          twitter: '',
          linkedIn: '',
          articles: [
            {
              title: 'Strategery iQ takes Perfomance Management into the next millenia',
              source: 'Wired',
              ref: ''
            },
            {
              title: 'DoloLabs does it again',
              source: 'iGadget',
              ref: ''
            },
            {
              title: 'DoloLabs has launched the new generation of Management Tools.',
              source: 'TechWiz',
              ref: ''
            }
          ]
        },
        {
          title: 'Today®',
          lulu: 'Organize.',
          detType: 'promo',
          displayTitle: 'Today',
          logo: 'today/td_shad2',
          req: 'td',
          smarter: 'Organize',
          color: 'pink',
          color2: 'light-blue',
          tagline: 'Daily & Project Management with Purpose.',
          desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.',
          highlights: [
            { 
              title:'Project Management with Purpose.',
              img: 'https://i.pinimg.com/originals/4f/54/e3/4f54e3c38b45687bb3d0ecc9d4d9c54f.png',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
            },
            { 
              title:'Event Calendar.',
              img: 'https://i.pinimg.com/originals/4f/54/e3/4f54e3c38b45687bb3d0ecc9d4d9c54f.png',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
            },
            { 
              title:'Daily Planning.',
              img: 'https://mir-s3-cdn-cf.behance.net/project_modules/fs/b5827590784099.5e2048449e4cc.jpg',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
            },
            { 
              title:'Notes.',
              img: 'https://i.pinimg.com/736x/ab/12/77/ab1277b7ab0f09d1085e033794720dce--web-dashboard-dashboard-design.jpg',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
            },
            { 
              title:'Events.',
              img: 'https://assets.justinmind.com/wp-content/uploads/2019/08/mobile-banking-app-design-best-ui-patterns-1.png',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
            },
            { 
              title:'Messaging.',
              img: 'https://i.pinimg.com/originals/81/83/59/8183590a65d3096e98e1c45ec1e7f774.jpg',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
            },
            { 
              title:'Video Chat.',
              img: 'https://mir-s3-cdn-cf.behance.net/project_modules/fs/b8df9a90827331.5e2151aa78086.jpg',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
            },
          ],
          prodVid: 'oNg0V89D79I',
          linkOut: 'today.dololabs.com',
          bgImg: '',
          appleOut: '',
          androidOut: '',
          twitter: '',
          linkedIn: '',
          articles: [
            {
              title: 'Project Management Done right.',
              source: 'Wired',
              ref: ''
            },
            {
              title: 'Top earning PM tool that just turned 1.',
              source: 'iGadget',
              ref: ''
            },
            {
              title: 'The best of all worlds.',
              source: 'TechWiz',
              ref: ''
            }
          ]
        },
        {
          title: 'Avenues®',
          lulu: 'Educate.',
          detType: 'promo',
          displayTitle: 'Avenues',
          logo: 'aveneus/av_shad2',
          req: 'av',
          smarter: 'Learn',
          color: 'indigo',
          color2: 'lime',
          tagline: 'Stop Thinking. Start Doing.',
          desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.',
          highlights: [
            { 
              title:'Learning Management System.',
              img: 'https://i.pinimg.com/originals/4f/54/e3/4f54e3c38b45687bb3d0ecc9d4d9c54f.png',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
            },
            { 
              title:'Day One training plan.',
              img: 'https://i.pinimg.com/originals/4f/54/e3/4f54e3c38b45687bb3d0ecc9d4d9c54f.png',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
            },
            { 
              title:'On the Go Access.',
              img: 'https://mir-s3-cdn-cf.behance.net/project_modules/fs/b5827590784099.5e2048449e4cc.jpg',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
            },
            { 
              title:'Q-Guides.',
              img: 'https://i.pinimg.com/736x/ab/12/77/ab1277b7ab0f09d1085e033794720dce--web-dashboard-dashboard-design.jpg',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
            },
            { 
              title:'Minimize the Learning Curve.',
              img: 'https://assets.justinmind.com/wp-content/uploads/2019/08/mobile-banking-app-design-best-ui-patterns-1.png',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
            },
            { 
              title:'Measurable ROI.',
              img: 'https://i.pinimg.com/originals/81/83/59/8183590a65d3096e98e1c45ec1e7f774.jpg',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
            },
          ],
          prodVid: 'oNg0V89D79I',
          linkOut: 'avenues.dololabs.com',
          bgImg: '',
          appleOut: '',
          androidOut: '',
          twitter: '',
          linkedIn: '',
          articles: [
            {
              title: 'Simple, Beautiful, all Things Strategery Avenues.',
              source: 'Wired',
              ref: ''
            },
            {
              title: 'Who knew learning wasn\'t about learning',
              source: 'iGadget',
              ref: ''
            },
            {
              title: 'Strategery Avenues is on top.',
              source: 'TechWiz',
              ref: ''
            }
          ]
        },
        {
          title: 'People®',
          lulu: 'Project.',
          detType: 'promo',
          displayText: 'People',
          logo: 'people/pe_shad2',
          req: 'pe',
          smarter: 'HR',
          color: 'orange',
          color2: 'cyan',
          tagline: 'Better Hires Faster.',
          desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.',
          highlights: [
            { 
              title:'Open Job Marketing.',
              img: 'https://i.pinimg.com/originals/4f/54/e3/4f54e3c38b45687bb3d0ecc9d4d9c54f.png',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
            },
            { 
              title:'Applicant Tracking.',
              img: 'https://i.pinimg.com/originals/4f/54/e3/4f54e3c38b45687bb3d0ecc9d4d9c54f.png',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
            },
            { 
              title:'Constant Bench Strength.',
              img: 'https://mir-s3-cdn-cf.behance.net/project_modules/fs/b5827590784099.5e2048449e4cc.jpg',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
            },
            { 
              title:'Automated Sourcing and Screening.',
              img: 'https://i.pinimg.com/736x/ab/12/77/ab1277b7ab0f09d1085e033794720dce--web-dashboard-dashboard-design.jpg',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
            },
            { 
              title:'Interview Assistance.',
              img: 'https://assets.justinmind.com/wp-content/uploads/2019/08/mobile-banking-app-design-best-ui-patterns-1.png',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
            },
            { 
              title:'Networking Events.',
              img: 'https://i.pinimg.com/originals/81/83/59/8183590a65d3096e98e1c45ec1e7f774.jpg',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
            },
          ],
          prodVid: 'oNg0V89D79I',
          linkOut: 'people.dololabs.com',
          bgImg: '',
          appleOut: '',
          androidOut: '',
          twitter: '',
          linkedIn: '',
          articles: [
            {
              title: 'Strategery People is what well all needed but didn\'t know it',
              source: 'iGadget',
              ref: ''
            },
            {
              title: 'What you should know about Strategery People',
              source: 'iGadget',
              ref: ''
            },
            {
              title: 'DoloLabs Strategery People is the Captain Obivious of the HR world.',
              source: 'Wired',
              ref: ''
            }
          ]
        }
      ],
      windows: [
        {
          title: 'Strategery®.',
          location: 0,
          subtitle: 'Better Tools. Better Results.',
          wTitle: 'Strategery',
          content: '',
          img: '',
          list: [],
          bg: 'white',
          halfBg: false,
          bgImg: '',
          prodList: [],
        },
        {
          title: 'Performance Management.',
          location: 1,
          subtitle: 'Create Proactive Influence not reactive observation.',
          wTitle: 'Performance',
          content: '',
          img: '',
          list: [
            'Customizable Performance Tracking.',
            'Project Management with Purpose.',
            'Daily Tasks, Notes, Event Calendar, Networking Events.',
            'Learning Management with measureable ROI.',
            'Pin Point Talent Acquisition.',
            'Path of least resistance to a more healthy bottom line.'
          ],
          bg: 'white',
          halfBg: true,
          bgImg: 'https://cdn.dribbble.com/users/56900/screenshots/3530662/trv_scene2.gif',
          prodList: [],
        },
        {
          title: 'RealTime Analysis.',
          location: 3,
          subtitle: 'Measurement Always Precedes Management.',
          wTitle: 'RealTime',
          content: 'To succede you must first understand what it takes to be successful. Strategery iQ® makes it easy to create measurement around the performance vital to your companies overall health. Once these measurements are created Strategery® will analyze those metics, highlight any areas of need and provide support in those areas untilizing it\'s internal AI engine.',
          img: 'https://towntechrepairs.com/wp-content/uploads/2017/02/iphone-transparent-bg-300x300.png',
          list: [],
          bg: 'bgGrey',
          halfBg: false,
          bgImg: '',
          prodList: []
        },
        {
          title: 'Everything in one place.',
          location: 3,
          subtitle: '1 Tool for everything.',
          wTitle: 'Everything',
          content: '',
          img: '',
          list: [],
          bg: 'white',
          halfBg: false,
          bgImg: '',
          prodList: [
            {
              title: 'iQ®',
              detType: 'promo',
              displayTitle: 'iQ',
              logo: 'iq/IQ_shadow2.png',
              req: 'iq',
              smarter: 'Measurement',
              color: 'amber',
              color2: 'primary2',
              tagline: 'Work Smarter.',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.',
              highlights: [
                { 
                  title:'Performance Measurement.',
                  img: 'https://i.pinimg.com/originals/4f/54/e3/4f54e3c38b45687bb3d0ecc9d4d9c54f.png',
                  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
                },
                { 
                  title:'Create Accountability.',
                  img: 'https://mir-s3-cdn-cf.behance.net/project_modules/fs/b5827590784099.5e2048449e4cc.jpg',
                  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
                },
                { 
                  title:'Customizable Metrics.',
                  img: 'https://i.pinimg.com/736x/ab/12/77/ab1277b7ab0f09d1085e033794720dce--web-dashboard-dashboard-design.jpg',
                  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
                },
                { 
                  title:'Automated.',
                  img: 'https://assets.justinmind.com/wp-content/uploads/2019/08/mobile-banking-app-design-best-ui-patterns-1.png',
                  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
                },
                { 
                  title:'Easy to understand results.',
                  img: 'https://i.pinimg.com/originals/81/83/59/8183590a65d3096e98e1c45ec1e7f774.jpg',
                  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
                },
                { 
                  title:'iQ Report Card.',
                  img: 'https://mir-s3-cdn-cf.behance.net/project_modules/fs/b8df9a90827331.5e2151aa78086.jpg',
                  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
                },
              ],
              prodVid: 'v=lzQyH-nX0u0',
              linkOut: 'iq.dololabs.com',
              bgImg: '',
              appleOut: '',
              androidOut: '',
              twitter: '',
              linkedIn: '',
              articles: [
                {
                  title: 'Strategery iQ takes Perfomance Management into the next millenia',
                  source: 'Wired',
                  ref: ''
                },
                {
                  title: 'DoloLabs does it again',
                  source: 'iGadget',
                  ref: ''
                },
                {
                  title: 'DoloLabs has launched the new generation of Management Tools.',
                  source: 'TechWiz',
                  ref: ''
                }
              ]
            },
            {
              title: 'Today®',
              detType: 'promo',
              displayTitle: 'Today',
              logo: 'today/td_shadow2.png',
              req: 'td',
              smarter: 'Organize',
              color: 'pink',
              color2: 'light-blue',
              tagline: 'Daily & Project Management with Purpose.',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.',
              highlights: [
                { 
                  title:'Project Management with Purpose.',
                  img: 'https://i.pinimg.com/originals/4f/54/e3/4f54e3c38b45687bb3d0ecc9d4d9c54f.png',
                  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
                },
                { 
                  title:'Event Calendar.',
                  img: 'https://i.pinimg.com/originals/4f/54/e3/4f54e3c38b45687bb3d0ecc9d4d9c54f.png',
                  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
                },
                { 
                  title:'Daily Planning.',
                  img: 'https://mir-s3-cdn-cf.behance.net/project_modules/fs/b5827590784099.5e2048449e4cc.jpg',
                  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
                },
                { 
                  title:'Notes.',
                  img: 'https://i.pinimg.com/736x/ab/12/77/ab1277b7ab0f09d1085e033794720dce--web-dashboard-dashboard-design.jpg',
                  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
                },
                { 
                  title:'Events.',
                  img: 'https://assets.justinmind.com/wp-content/uploads/2019/08/mobile-banking-app-design-best-ui-patterns-1.png',
                  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
                },
                { 
                  title:'Messaging.',
                  img: 'https://i.pinimg.com/originals/81/83/59/8183590a65d3096e98e1c45ec1e7f774.jpg',
                  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
                },
                { 
                  title:'Video Chat.',
                  img: 'https://mir-s3-cdn-cf.behance.net/project_modules/fs/b8df9a90827331.5e2151aa78086.jpg',
                  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
                },
              ],
              prodVid: 'oNg0V89D79I',
              linkOut: 'today.dololabs.com',
              bgImg: '',
              appleOut: '',
              androidOut: '',
              twitter: '',
              linkedIn: '',
              articles: [
                {
                  title: 'Project Management Done right.',
                  source: 'Wired',
                  ref: ''
                },
                {
                  title: 'Top earning PM tool that just turned 1.',
                  source: 'iGadget',
                  ref: ''
                },
                {
                  title: 'The best of all worlds.',
                  source: 'TechWiz',
                  ref: ''
                }
              ]
            },
            {
              title: 'Avenues®',
              detType: 'promo',
              displayTitle: 'Avenues',
              logo: 'aveneus/av_shadow2.png',
              req: 'av',
              smarter: 'Learn',
              color: 'indigo',
              color2: 'lime',
              tagline: 'Stop Thinking. Start Doing.',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.',
              highlights: [
                { 
                  title:'Learning Management System.',
                  img: 'https://i.pinimg.com/originals/4f/54/e3/4f54e3c38b45687bb3d0ecc9d4d9c54f.png',
                  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
                },
                { 
                  title:'Day One training plan.',
                  img: 'https://i.pinimg.com/originals/4f/54/e3/4f54e3c38b45687bb3d0ecc9d4d9c54f.png',
                  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
                },
                { 
                  title:'On the Go Access.',
                  img: 'https://mir-s3-cdn-cf.behance.net/project_modules/fs/b5827590784099.5e2048449e4cc.jpg',
                  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
                },
                { 
                  title:'Q-Guides.',
                  img: 'https://i.pinimg.com/736x/ab/12/77/ab1277b7ab0f09d1085e033794720dce--web-dashboard-dashboard-design.jpg',
                  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
                },
                { 
                  title:'Minimize the Learning Curve.',
                  img: 'https://assets.justinmind.com/wp-content/uploads/2019/08/mobile-banking-app-design-best-ui-patterns-1.png',
                  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
                },
                { 
                  title:'Measurable ROI.',
                  img: 'https://i.pinimg.com/originals/81/83/59/8183590a65d3096e98e1c45ec1e7f774.jpg',
                  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
                },
              ],
              prodVid: 'oNg0V89D79I',
              linkOut: 'avenues.dololabs.com',
              bgImg: '',
              appleOut: '',
              androidOut: '',
              twitter: '',
              linkedIn: '',
              articles: [
                {
                  title: 'Simple, Beautiful, all Things Strategery Avenues.',
                  source: 'Wired',
                  ref: ''
                },
                {
                  title: 'Who knew learning wasn\'t about learning',
                  source: 'iGadget',
                  ref: ''
                },
                {
                  title: 'Strategery Avenues is on top.',
                  source: 'TechWiz',
                  ref: ''
                }
              ]
            },
            {
              title: 'People®',
              detType: 'promo',
              displayText: 'People',
              logo: 'people/pe_shadow.2png',
              req: 'pe',
              smarter: 'HR',
              color: 'orange',
              color2: 'cyan',
              tagline: 'Better Hires Faster.',
              desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.',
              highlights: [
                { 
                  title:'Open Job Marketing.',
                  img: 'https://i.pinimg.com/originals/4f/54/e3/4f54e3c38b45687bb3d0ecc9d4d9c54f.png',
                  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
                },
                { 
                  title:'Applicant Tracking.',
                  img: 'https://i.pinimg.com/originals/4f/54/e3/4f54e3c38b45687bb3d0ecc9d4d9c54f.png',
                  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
                },
                { 
                  title:'Constant Bench Strength.',
                  img: 'https://mir-s3-cdn-cf.behance.net/project_modules/fs/b5827590784099.5e2048449e4cc.jpg',
                  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
                },
                { 
                  title:'Automated Sourcing and Screening.',
                  img: 'https://i.pinimg.com/736x/ab/12/77/ab1277b7ab0f09d1085e033794720dce--web-dashboard-dashboard-design.jpg',
                  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
                },
                { 
                  title:'Interview Assistance.',
                  img: 'https://assets.justinmind.com/wp-content/uploads/2019/08/mobile-banking-app-design-best-ui-patterns-1.png',
                  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
                },
                { 
                  title:'Networking Events.',
                  img: 'https://i.pinimg.com/originals/81/83/59/8183590a65d3096e98e1c45ec1e7f774.jpg',
                  desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Id diam vel quam elementum pulvinar etiam non quam. Vestibulum sed arcu non odio euismod lacinia at quis risus.'
                },
              ],
              prodVid: 'oNg0V89D79I',
              linkOut: 'people.dololabs.com',
              bgImg: '',
              appleOut: '',
              androidOut: '',
              twitter: '',
              linkedIn: '',
              articles: [
                {
                  title: 'Strategery People is what well all needed but didn\'t know it',
                  source: 'iGadget',
                  ref: ''
                },
                {
                  title: 'What you should know about Strategery People',
                  source: 'iGadget',
                  ref: ''
                },
                {
                  title: 'DoloLabs Strategery People is the Captain Obivious of the HR world.',
                  source: 'Wired',
                  ref: ''
                }
              ]
            }
          ]
        },
        {
          title: 'Strategery.',
          location: 0,
          subtitle: 'The only tool you need to get the job done.',
          wTitle: 'Get Started',
          content: '',
          img: '',
          list: [],
          bg: 'bgGrey',
          halfBg: false,
          bgImg: '',
          prodList: [],
        }
      ],
      getStartedDialog: false,
      mobiGetStartedDialog: false,
    }
  },
  methods: {
    window(w){
      const a = w - 1
      this.home = a
    },
    last(){
      this.home = this.home - 1
    },
    next(){
      this.home = this.home + 1
    },
    openProdDialog(p) {
      this.prodDialog = true
      this.prodDets = p
    },
    killProdDialog(){
      this.prodDialog = false
      this.prodDets = null
    },
    openMobiGetStarted() {
        this.mobiGetStartedDialog = true
    },
    openGetStarted() {
        this.getStartedDialog = true
    },
    killGetStarted() {
        this.mobiGetStartedDialog = false
        this.getStartedDialog = false
    }
  }
}
</script>


<style lang="scss" scoped>

  .banner {
    height: 98vh;
    width: 100%;

    .banner-bg {
      position: absolute;
      top: 0;
      left: 0;
      height: 64vh;
      width: 100%;
    }

    .banner-img {
      position: absolute;
      top: 30%;
      left: 24%;
      width: 100%;
      z-index: 2;
    }

    .banner-title {
      position: absolute;
      top: 58%;
      left: 27.5%;
      width: 45%;
      z-index: 2;

      .title-t {
        font-size: 4.2em;
        margin-bottom: 15px;
        letter-spacing: -5px;
        margin-bottom: 70px;
        text-shadow: 0px 30px 25px rgba(0,0,0,.32);
      }

      .title-s {
        font-size: 22px;
        //line-height: 110px;
        //letter-spacing: -10px;
      }
    } 
  }

  .section {
      position: relative;
      padding: 125px 0;
      width: 100%;

      &.tsm {
          min-height: 50vh;
      }
      &.tmd {
          min-height: 78vh;
      }
      &.tlg {
          min-height: 98vh;
      }

      .det-info {
          font-size: 22px
      }

      .round {
        border-radius: 50% !important;

      }

      .block-bg {
        position: absolute;
        height: 80%;
        width: 54%;
        right: 0%;
        top: -10%; 
        border-radius: 300px 0 0 300px;

        &.rt {
          position: absolute;
          height: 80%;
          width: 54%;
          left: 0%;
          top: -10%;
          border-radius: 0 220px 220px 0;
        }
      }

      .block-text {
        position: absolute;
          height: 50%;
          width: 40%;
          left: 30%;
          top: 10%;
          font-size: 2em;
          line-height: 40px;
          z-index: 2;

        &.rt {
          .block-text {
            position: absolute;
            height: 50%;
            width: 40%; 
            right: 30%;
            bottom: 10%;
            font-size: 2em;
            line-height: 40px;
          }
        }
      }

      .logo-sm {
        background-size: contain;
        background-position: center;

        &.iq {
            background-image: url('../assets/logos/iq/iq_shad2.png');
        }
        &.td {
            background-image: url('../assets/logos/today/td_shad2.png')
        }
        &.av {
            background-image: url('../assets/logos/avenues/av_shad2.png')
        }
        &.pe {
            background-image: url('../assets/logos/people/pe_shad2.png')
        }
      }

      &.liner {
        padding: 0;
        height: 12px;
        border-radius: 20px;

        &.l {
          width: 84%;

          &.rt {
            margin-left: 16%
          }
        }
        &.m {
          height: 28px;
          width: 64%;

          &.rt {
            margin-left: 36%
          }
        }
        &.s {
          height: 8px;
          width: 44%;

          &.rt {
            margin-left: 56%
          }
        }
      }

      .tag-sec {
        position: absolute;
        height: 80%;
        top: 0;
        left: 10%;
        width: 80%;
        border-radius: 0 0 220px 220px;
      }

      .bg-circle {
        position: absolute;
        bottom: -40%;
        right: -25%;
        height: 80%;
        width: 50%;
        border-radius: 50%;
        z-index: 1;
      }

      .bg-circle-ls {
        position: absolute;
        bottom: -10%;
        left: -4%;
        height: 300px;
        width: 300px;
        border-radius: 50%;
        z-index: 1;
        opacity: .45;

        &.ol {
          border: 30px solid;

          &.amber-line {
            border-color: #FFC107
          }
          &.tertiary-line {
            border-color: #00BCD4
          }
          &.accent-line {
            border-color: #2196F3
          }
          &.black-line {
            border-color: #000000
          }
        }
      }

      .bg-hollow {
        position: absolute;
        height: 134%;
        width: 28%;
        border: 20px solid;
        opacity: .34;
        border-radius: 0 0 220px 220px;
        z-index: 1;

        &.tl {
          left: 1.5%;
          top: -40px;
        }

        &.tr {
          right: 4.5%;
          top: -40px;
        }

        &.ml {
          left: -40px;
          top: 34%;
          height: 40%;
          width: 60%;
          border-radius: 0 120px 120px 0;
        }

        &.mlb {
          left: -40px;
          bottom: -15%;
          height: 30%;
          width: 60%;
          border-radius: 0 220px 220px 0;
        }

        &.diag-rt {
          top: 34%;
          right: -12%;
          transform: rotate(30deg);
          border-radius: 0 0 300px 300px;
        }

        &.diag-lft {
          top: 34%;
          left: -10%;
          transform: rotate(-30deg)
        }

        &.amber-line {
          border-color: #FFC107
        }
        &.tertiary-line {
          border-color: #00BCD4
        }
        &.accent-line {
          border-color: #2196F3
        }
        &.black-line {
          border-color: #000000
        }
      }

      .bg-text {
        position: absolute;
        height: 100%;
        width: 100%;
        font-size: 14em;
        color: #fafafa !important;
        padding-left: 5%;
        letter-spacing: -22px;
        white-space: nowrap;
      }

      .big {
        font-size: 4.2em;
        line-height: 70px;
        letter-spacing: -2.5px;
        //text-shadow: 0px 30px 25px rgba(0,0,0,.24);
      }

      .section-details {
        position: absolute;
        padding: 25px 0;
        height: 90%;
        width: 80%;
        top: 5%;
        left: 10%;
        z-index: 2;

        .prod-container {
          width: 75%;

          .prod-card {
            padding: 24px;

            .pc-title {
              font-size: 32px;
            }

            .pc-logo {
              margin-top: 48px;
            }
          }
        }

        .ev-chips-container {
          max-width: 50%;
          margin-top: 32px;

          .ev-chip {
            font-size: 18px;
          }
        }
      }

      .footer-link {
          cursor: pointer;
          color: #9e9e9e !important;
          text-decoration: none !important;

          &:hover {
              color: #FFC107 !important;
              text-decoration: none !important;
          }
      }
  }

  .bg-rect {
    position: absolute;
    height: 45%;
    width: 10%;
    border: 30px solid;
    top: 27.5%;
    left:45%;
    border-radius: 220px;

    &.amber-line {
      border-color: #FFC107
    }
    &.tertiary-line {
      border-color: #00BCD4
    }
    &.accent-line {
      border-color: #2196F3
    }
    &.black-line {
      border-color: #000000
    }

    .balls {
      position: absolute;
      height: 60%;
      width: 60px;
      top: 20%;
      right: -45px;

      .b {
        height: 60px;
        width: 60px;
        border-radius: 50%;
      }
    }
  }

  .tablet {
    .banner {
      height: 98vh;
      width: 100%;

      .banner-bg {
        position: absolute;
        top: 0;
        left: 0;
        height: 64vh;
        width: 100%;
      }

      .banner-img {
        position: absolute;
        top: 30%;
        left: 24%;
        width: 100%;
        z-index: 2;
      }

      .banner-title {
        position: absolute;
        top: 58%;
        left: 27.5%;
        width: 45%;
        z-index: 2;

        .title-t {
          font-size: 3.2em;
          margin-bottom: 15px;
          letter-spacing: -5px;
          margin-bottom: 70px;
          text-shadow: 0px 30px 25px rgba(0,0,0,.32);
        }

        .title-s {
          font-size: 18px;
          //line-height: 110px;
          //letter-spacing: -10px;
        }
      } 
    }

    .section {
        position: relative;
        padding: 125px 0;
        width: 100%;

        &.tsm {
            min-height: 50vh;
        }
        &.tmd {
            min-height: 78vh;
        }
        &.tlg {
            min-height: 105vh;

            /* &.everything {
              min-height: 125vh;
            } */
        }

        .det-info {
          font-size: 14px
        }

        .round {
          border-radius: 50% !important;

        }

        .block-bg {
          position: absolute;
          height: 60%;
          width: 74%;
          right: 0%;
          top: -10%; 
          border-radius: 300px 0 0 300px;

          &.rt {
            position: absolute;
            height: 60%;
            width: 74%;
            left: 0%;
            top: -10%;
            border-radius: 0 220px 220px 0;
          }
        }

        .block-text {
          position: absolute;
          height: 50%;
          width: 60%;
          left: 10%;
          top: 30%;
          font-size: 1.2em;
          line-height: 26px;
          z-index: 2;

          &.rt {
            position: absolute;
            height: 50%;
            width: 60%;
            top: 20%;
            left: 30%;
            bottom: 5%;
            font-size: 1.2em;
            line-height: 40px;
          }
        }

        .logo-sm {
          background-size: contain;
          background-position: center;

          &.iq {
              background-image: url('../assets/logos/iq/iq_shad2.png');
          }
          &.td {
              background-image: url('../assets/logos/today/td_shad2.png')
          }
          &.av {
              background-image: url('../assets/logos/avenues/av_shad2.png')
          }
          &.pe {
              background-image: url('../assets/logos/people/pe_shad2.png')
          }
        }

        &.liner {
          padding: 0;
          height: 8px;
          border-radius: 20px;

          &.l {
            width: 84%;

            &.rt {
              margin-left: 16%
            }
          }
          &.m {
            height: 24px;
            width: 64%;

            &.rt {
              margin-left: 36%
            }
          }
          &.s {
            height: 4px;
            width: 44%;

            &.rt {
              margin-left: 56%
            }
          }
        }

        .tag-sec {
          position: absolute;
          height: 80%;
          top: 0;
          left: 5%;
          width: 90%;
          border-radius: 0 0 220px 220px;

          .section-details {
            position: absolute;
            padding: 25px 0;
            height: 90%;
            width: 80%;
            top: 5%;
            left: 18%;
            z-index: 2;
          }
        }

        .bg-circle {
          position: absolute;
          bottom: -40%;
          right: -25%;
          height: 80%;
          width: 50%;
          border-radius: 50%;
          z-index: 1;
        }

        .bg-circle-ls {
          position: absolute;
          bottom: -10%;
          left: -4%;
          height: 300px;
          width: 300px;
          border-radius: 50%;
          z-index: 1;
          opacity: .45;

          &.ol {
            border: 10px solid;

            &.amber-line {
              border-color: #FFC107
            }
            &.tertiary-line {
              border-color: #00BCD4
            }
            &.accent-line {
              border-color: #2196F3
            }
            &.black-line {
              border-color: #000000
            }
          }
        }

        .bg-hollow {
          position: absolute;
          height: 134%;
          width: 28%;
          border: 10px solid;
          opacity: .34;
          border-radius: 0 0 220px 220px;
          z-index: 1;

          &.tl {
            left: 1.5%;
            top: -40px;
          }

          &.tr {
            right: 4.5%;
            top: -40px;
          }

          &.ml {
            left: -40px;
            top: 34%;
            height: 40%;
            width: 60%;
            border-radius: 0 120px 120px 0;
          }

          &.mlb {
            left: -40px;
            bottom: -15%;
            height: 30%;
            width: 60%;
            border-radius: 0 220px 220px 0;
          }

          &.diag-rt {
            top: 34%;
            right: -12%;
            transform: rotate(30deg);
            border-radius: 0 0 300px 300px;
          }

          &.diag-lft {
            top: 34%;
            left: -10%;
            transform: rotate(-30deg)
          }

          &.amber-line {
            border-color: #FFC107
          }
          &.tertiary-line {
            border-color: #00BCD4
          }
          &.accent-line {
            border-color: #2196F3
          }
          &.black-line {
            border-color: #000000
          }
        }

        .bg-text {
          position: absolute;
          height: 100%;
          width: 100%;
          font-size: 14em;
          color: #fafafa !important;
          padding-left: 5%;
          letter-spacing: -22px;
          white-space: nowrap;
        }

        .big {
          font-size: 2.6em;
          line-height: 40px;
          letter-spacing: -2.5px;
          //text-shadow: 0px 30px 25px rgba(0,0,0,.24);
        }

        .section-details {
          position: absolute;
          padding: 25px 0;
          height: 90%;
          width: 80%;
          top: 5%;
          left: 10%;
          z-index: 2;

          .prod-container {
            width: 100%;

            .prod-card {
              padding: 18px;

              .pc-title {
                font-size: 24px;
              }

              .pc-logo {
                margin-top: 64px;
              }
            }

          }

          .ev-chips-container {
            max-width: 70%;
            margin-top: 0;

            .ev-chip {
              font-size: 12px;
            }
          }

        }

        .footer-link {
            cursor: pointer;
            color: #9e9e9e !important;
            text-decoration: none !important;

            &:hover {
                color: #FFC107 !important;
                text-decoration: none !important;
            }
        }
    }

    .bg-rect {
      position: absolute;
      height: 45%;
      width: 10%;
      border: 30px solid;
      top: 27.5%;
      left:45%;
      border-radius: 220px;

      &.amber-line {
        border-color: #FFC107
      }
      &.tertiary-line {
        border-color: #00BCD4
      }
      &.accent-line {
        border-color: #2196F3
      }
      &.black-line {
        border-color: #000000
      }

      .balls {
        position: absolute;
        height: 60%;
        width: 60px;
        top: 20%;
        right: -45px;

        .b {
          height: 60px;
          width: 60px;
          border-radius: 50%;
        }
      }
    }
  }

  .mobi {
    .banner {
      height: 98vh;
      width: 100%;

      .banner-bg {
        position: absolute;
        top: 0;
        left: 0;
        height: 64vh;
        width: 100%;
      }

      .banner-img {
        position: absolute;
        top: 44%;
        left: 40%;
        width: 20%;
        z-index: 2;
      }

      .banner-title {
        position: absolute;
        top: 58%;
        left: 17.5%;
        width: 65%;
        z-index: 2;

        .title-t {
          font-size: 40px;
          margin-bottom: 15px;
          line-height: 50px;
          letter-spacing: -2.5px;
          @media screen and (max-width: 320px) {
            margin-bottom: 40px;
          }
          margin-bottom: 80px
        }

        .title-s {
          font-size: 16px;
          line-height: 30px;
        }
      } 
    }

    .bg-rect {
      position: absolute;
      height: 45%;
      width: 28%;
      border: 20px solid;
      top: 27.5%;
      left:36%;
      border-radius: 220px;

      &.amber-line {
        border-color: #FFC107
      }
      &.tertiary-line {
        border-color: #00BCD4
      }
      &.accent-line {
        border-color: #2196F3
      }
      &.black-line {
        border-color: #000000
      }

      .balls {
        position: absolute;
        height: 60%;
        width: 60px;
        top: 20%;
        right: -45px;

        .b {
          height: 60px;
          width: 60px;
          border-radius: 50%;
        }
      }
    }

    .section {
        position:relative;
        padding: 55px 0;
        width: 100%;

        @media screen and (max-width: 320px) {
          &.tsm {
              min-height: 50vh;
          }
          &.tmd {
              min-height: 78vh;
          }
          &.tlg {
              min-height: 98vh;

              &.mega {
                min-height: 275%;
              }

              &.everything {
                min-height: 130vh;
              }
          }
        }

        @media screen and (min-width: 321px) and (max-width: 375px) {
          &.tsm {
              min-height: 34vh;
          }
          &.tmd {
              min-height: 64vh;
          }
          &.tlg {
              min-height: 80vh;

              &.mega {
                min-height: 226%;
              }

              &.everything {
                min-height: 110vh;
              }
          }
        }

        @media screen and (min-width: 376px) and (max-width: 413px) {
          &.tsm {
              min-height: 24vh;
          }
          &.tmd {
              min-height: 54vh;
          }
          &.tlg {
              min-height: 70vh;

              &.mega {
                min-height: 188%;
              }

              &.everything {
                min-height: 96vh;
              }
          }
        }

        @media screen and (min-width: 414px) {
          &.tsm {
              min-height: 36vh;
          }
          &.tmd {
              min-height: 58vh;
          }
          &.tlg {
              min-height: 84vh;

              &.mega {
                min-height: 216%;
              }

              &.everything {
                min-height: 105vh;
              }
          }
        }

        .round {
          border-radius: 50% !important;

        }

        .logo-sm {
          background-size: contain;
          background-position: center;

          &.iq {
              background-image: url('../assets/logos/iq/iq_shad2.png');
          }
          &.td {
              background-image: url('../assets/logos/today/td_shad2.png')
          }
          &.av {
              background-image: url('../assets/logos/avenues/av_shad2.png')
          }
          &.pe {
              background-image: url('../assets/logos/people/pe_shad2.png')
          }
        }

        &.liner {
          padding: 0;
          height: 8px;
          border-radius: 20px;

          &.l {
            width: 84%;

            &.rt {
              margin-left: 16%
            }
          }
          &.m {
            height: 14px;
            width: 64%;

            &.rt {
              margin-left: 36%
            }
          }
          &.s {
            height: 4px;
            width: 44%;

            &.rt {
              margin-left: 56%
            }
          }
        }

        .tag-sec {
          position: absolute;
          height: 80%;
          top: 10%;
          left: 5%;
          width: 90%;
          border-radius: 0 0 220px 220px;
        }

        .bg-circle {
          position: absolute;
          bottom: -10%;
          right: -198px;
          height: 300px;
          width: 300px;
          border-radius: 50%;
          z-index: 1;
        }

        .bg-circle-ls {
          position: absolute;
          bottom: -20%;
          left: -65px;
          height: 150px;
          width: 150px;
          border-radius: 50%;
          z-index: 1;
          opacity: .45;

          &.ol {
            border: 10px solid;

            &.amber-line {
              border-color: #FFC107
            }
            &.tertiary-line {
              border-color: #00BCD4
            }
            &.accent-line {
              border-color: #2196F3
            }
            &.black-line {
              border-color: #000000
            }
          }
        }

        .bg-hollow {
          position: absolute;
          height: 134%;
          width: 60%;
          border: 10px solid;
          opacity: .34;
          border-radius: 0 0 220px 220px;
          z-index: 1;

          &.tl {
            left: 1.5%;
            top: -40px;
          }

          &.tr {
            right: 4.5%;
            top: -40px;
          }

          &.ml {
            left: -40px;
            top: 34%;
            height: 20%;
            width: 60%;
            border-radius: 0 120px 120px 0;
          }

          &.mlb {
            left: -6px;
            bottom: -10%;
            height: 20%;
            width: 80%;
            border-radius: 0 220px 220px 0;
          }

          &.diag-rt {
            top: 12%;
            right: -27%;
            transform: rotate(30deg)
          }

          &.diag-lft {
            top: 34%;
            left: -10%;
            transform: rotate(-30deg)
          }

          &.amber-line {
            border-color: #FFC107
          }
          &.tertiary-line {
            border-color: #00BCD4
          }
          &.accent-line {
            border-color: #2196F3
          }
          &.black-line {
            border-color: #000000
          }
        }

        .bg-text {
          position: absolute;
          height: 100%;
          width: 100%;
          font-size: 14em;
          color: #fafafa !important;
          padding-left: 5%;
          letter-spacing: -22px;
          white-space: nowrap;
        }

        .big {
          font-size: 40px;
          line-height: 40px;
          letter-spacing: -2.5px;
        }

        .section-details {
          position: absolute;
          padding: 35px 0%;
          height: 100%;
          width: 80%;
          top: 5%;
          left: 10%;
          z-index: 2;
        }

        .footer-link {
            cursor: pointer;
            color: #9e9e9e !important;
            text-decoration: none !important;

            &:hover {
                color: #FFC107 !important;
                text-decoration: none !important;
            }
        }
    }




    .sthm-nav {
      position: absolute;
      bottom: 10%;
      left: 0;
      height: 70px;
      width: 42%;
      border-radius: 0 100px 100px 0;
      z-index: 2;
    }
    .sthm-nav2 {
      position: absolute;
      padding-left: 0%;
      bottom: 7%;
      left: -30px;
      height: 100px;
      width: 94%;
      z-index: 7;

      .cur-window {
        font-size: 2.5em;
      }

      .total-window {
        font-size: 1.4em;
        margin-bottom:30px;
        margin-left: 10px;
        width: 20%;
      }

      .window-btns {
        display: none;
      }
    }

    .sthm-nav-btn{
      position: fixed;
      right: 0;
      width: 100%;
      bottom: 1%;
      z-index: 4;

      
    }

    .window-content {
      position: absolute;
      right: 0;
      top: 0;
      height: 100%;
      width: 100%;
      overflow: hidden;
      border-radius: 0; 

      .off-box-diag {
        position: absolute;
        top: -35%;
        left:55%;
        height: 150%;
        width: 65%;
        transform: rotate(-25deg);
        overflow: hidden;
        
        .inner {
          transform: rotate(25deg);
          margin-left: -26%;
          padding: 14% 0% 0;
        }
      }
    }

    .window-title {
      position: absolute;
      width: 80%;
      left: 10%;
      bottom: -8%;
      font-size: 14em;
      color: black;
      opacity: .05;
      white-space: nowrap;
    }

    .wol-sec {
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0;
      top: 0;
      z-index: 2;
      
      .wol-title {
        position: absolute;
        opacity: 0;
        transition: all .67s;
        left: 10%;
        top: 16%;
        width: 55%;

        .w-title {
          opacity: 0;
          margin-left: -600px;
          transition: all .67s;
          font-size: 2.5em;
          z-index: 2;
          line-height: 40px;

          &.main {
            margin-top: 30%
          }
        }

        .w-subtitle {
          opacity: 0;
          transition: all .67s;
          font-size: 12px;
          margin-top: -20px;
          z-index: 2;
        }

        .w-content {
          transition: all .87s;
          opacity: 0;
          margin-left: 700px;
          z-index: 2;
          margin-top: 40px;
          width: 80%;
          line-height: 40px
        }

        &.active {
          transition-delay: .68s;
          opacity: 1;

          .w-title {
            opacity: 1;
            margin-left: 0;
            transition-delay: .24s;
          }
          .w-subtitle {
            opacity: 1;
            transition-delay: .34s;
            margin-top: 0px;
          }
          .w-content {
            opacity: 1;
            transition-delay: .44s;
            margin-left: 0;
          }
        }
      }

      .prod-list {
        position: fixed;
        width: 60%;
        right: 0%;
        bottom: 24%;
        transition: all .87s;
        opacity: 0;
        display: none;

        &.show {
          display: block
        }

        .prod-img {
          height: 234px;
          width: 146px;
          margin-left: 44px;
          background-size: contain;
          background-position: center;

            &.iq {
              background-image: url('../assets/logos/iq/iq_shad2.png');
            }
            &.td {
              width: 171px;
              background-image: url('../assets/logos/today/td_shad2.png');
            }
            &.av {
              background-image: url('../assets/logos/avenues/av_shad2.png');
            }
            &.pe {
              background-image: url('../assets/logos/people/pe_shad2.png');
            }
        }

        &.active {
          right: 20%;
          transition-delay: all .67s;
          opacity: 1;
        }
      }
    }

    .w-img {
      position: absolute;
      width: 44%;
      top: -30%;
      left: 44%;
      opacity: 0;
      transition: all .67s;
      z-index: 1;

      &.main {
        top: 0;
        width: 20%;
      }

      &.active {
        top: 5%;
        transform: rotate(2deg);
        opacity: 1;
        transition-delay: .68s;

        &.main {
          width: 20%;
          top: 20%;
          left: 56%;
        }
      }
    }
  }

  /* Scroll down indicator (bouncing) */
    @-webkit-keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
        -webkit-transform: translateX(0); }
    40% {
        -webkit-transform: translateX(-30px); }
    60% {
        -webkit-transform: translateX(-15px); } }
    @-moz-keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
        -moz-transform: translateX(0); }
    40% {
        -moz-transform: translateX(-30px); }
    60% {
        -moz-transform: translateX(-15px); } }
    @keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
        -webkit-transform: translateX(0);
        -moz-transform: translateX(0);
        -ms-transform: translateX(0);
        -o-transform: translateX(0);
        transform: translateX(0); }
    40% {
        -webkit-transform: translateX(-30px);
        -moz-transform: translateX(-30px);
        -ms-transform: translateX(-30px);
        -o-transform: translateX(-30px);
        transform: translateX(-30px); }
    60% {
        -webkit-transform: translateX(-15px);
        -moz-transform: translateX(-15px);
        -ms-transform: translateX(-15px);
        -o-transform: translateX(-15px);
        transform: translateX(-15px); } 
        }

</style>